import { render, staticRenderFns } from "./autoSyncConfig.vue?vue&type=template&id=38f8a4f6&scoped=true"
import script from "./autoSyncConfig.vue?vue&type=script&lang=js"
export * from "./autoSyncConfig.vue?vue&type=script&lang=js"
import style0 from "./autoSyncConfig.vue?vue&type=style&index=0&id=38f8a4f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f8a4f6",
  null
  
)

export default component.exports